module.exports = __webpack_public_path__ + "img/justdial1.19ee885d.png";